import {CampaignWorkflowState} from './campaignBase.types';

const campaignWorkflowInitialState: CampaignWorkflowState = {
  campaignWorkflowDataByStep: null,
  mappedUsers: {},
  socialCampaignFlowStatus: null,
};

export {campaignWorkflowInitialState};
